import React from "react";

/**
 * @component SortListIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <SortListIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const SortListIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={20}
      height={18}
      xmlns="http://www.w3.org/2000/svg"
      data-testid="SortListIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 0l4 4h-3v10h3l-4 4-4-4h3V4h-3l4-4zM9 13a1 1 0 110 2H1a1 1 0 110-2h8zm3-5a1 1 0 110 2H4a1 1 0 010-2h8zM9 3a1 1 0 010 2H1a1 1 0 010-2h8z"
      />
    </svg>
  )
);
SortListIcon.displayName = "SortListIcon";
export default SortListIcon;
